import type { InputChangeEvent } from "@tql/ui-components-react/kendo/inputs";
import { Button } from "@tql/ui-components-react/tql/buttons";
import { Input } from "@tql/ui-components-react/tql/inputs/beta";

type QuoteIdSearchProps = {
	setSearchValue: (value: number | null) => void;
	searchValue: number | null;
	onSetQuoteId: (quoteId: number | null) => void;
};

export const QuoteIdSearch = ({
	setSearchValue,
	searchValue,
	onSetQuoteId,
}: QuoteIdSearchProps) => {
	const handleChange = (e: InputChangeEvent) => {
		const digitsOnlyValue = String(e.value ?? "").replaceAll(/\D/g, "");
		const nextValue = digitsOnlyValue === "" ? null : Number(digitsOnlyValue);
		setSearchValue(nextValue);
		if (nextValue === null || nextValue === 0) {
			onSetQuoteId(null);
		}
	};

	const handleSearch = () => {
		onSetQuoteId(searchValue ? Number(searchValue) : null);
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === "Enter") {
			handleSearch();
		}
	};

	return (
		<div className={"quote-board-id-search-group"}>
			<div className={"quote-board-id-label"}>Quote ID</div>
			<div className={"quote-board-id-input"}>
				<Input
					data-testid={"quote-board-quote-id-input"}
					inputMode={"numeric"}
					onChange={handleChange}
					onKeyDown={handleKeyDown}
					pattern={"[0-9]*"}
					value={searchValue === null ? "" : String(searchValue)}
				/>
			</div>
			<div className={"quote-board-id-button"}>
				<Button onClick={handleSearch}>Search</Button>
			</div>
		</div>
	);
};
